/**
 * Mobile contact bubble — slides in from the left edge as the visitor scrolls.
 */
(function () {
  const mq = window.matchMedia('(max-width: 749px)');

  function init() {
    const bubble = document.querySelector('.contact-bubble');
    if (!bubble || !mq.matches) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const scrollRange = 160;
    let ticking = false;

    const hiddenOffset = () => {
      const rect = bubble.getBoundingClientRect();
      const left = parseFloat(getComputedStyle(bubble).left) || 0;
      return Math.ceil(rect.width + left + 16);
    };

    const setHidden = () => {
      bubble.style.setProperty('--contact-bubble-enter', `-${hiddenOffset()}px`);
      bubble.style.setProperty('--contact-bubble-opacity', '0');
      bubble.style.pointerEvents = 'none';
    };

    const update = () => {
      const y = window.scrollY;

      if (y <= 0) {
        setHidden();
        ticking = false;
        return;
      }

      if (reduced) {
        bubble.style.setProperty('--contact-bubble-enter', '0px');
        bubble.style.setProperty('--contact-bubble-opacity', '1');
        bubble.style.pointerEvents = 'auto';
        ticking = false;
        return;
      }

      const progress = Math.min(1, y / scrollRange);
      const offset = -hiddenOffset() * (1 - progress);
      bubble.style.setProperty('--contact-bubble-enter', `${offset}px`);
      bubble.style.setProperty('--contact-bubble-opacity', String(progress));
      bubble.style.pointerEvents = progress > 0.2 ? 'auto' : 'none';
      ticking = false;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    mq.addEventListener('change', () => {
      if (!mq.matches) bubble.style.removeProperty('--contact-bubble-enter');
    });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
